const initialState = {
  showLoader: true,
}

const playerLoaderReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SHOW_PLAYER_LOADER':
      return { showLoader: true }
    case 'HIDE_PLAYER_LOADER':
      return { showLoader: false }
    default:
      return state;
  }
}

export default playerLoaderReducer;
